/** Numeric database id from an event/holiday API row (not the slug `eventId` field). */
export function getEventNumericId(record) {
  if (record == null) return null
  const raw = record.id
  if (raw == null || raw === "") return null
  const n = Number(raw)
  return Number.isNaN(n) ? raw : n
}

export function eventRecordMatchesId(record, idOrSlug) {
  if (record == null || idOrSlug == null || idOrSlug === "") return false
  const key = String(idOrSlug)
  if (record.id != null && String(record.id) === key) return true
  if (record.eventId != null && String(record.eventId) === key) return true
  return false
}

/** Resolve stored selection (numeric id or legacy slug) to numeric API id. */
export function resolveEventNumericId(idOrSlug, events = [], holidays = []) {
  if (idOrSlug == null || idOrSlug === "") return null

  const key = String(idOrSlug)
  const direct = Number(idOrSlug)
  if (!Number.isNaN(direct) && String(direct) === key) return direct

  const matchedEvent = (Array.isArray(events) ? events : []).find((e) =>
    eventRecordMatchesId(e, key),
  )
  if (matchedEvent) return getEventNumericId(matchedEvent)

  const matchedHoliday = (Array.isArray(holidays) ? holidays : []).find((h) =>
    eventRecordMatchesId(h, key),
  )
  if (matchedHoliday) return getEventNumericId(matchedHoliday)

  return null
}

/** Coerce to numeric `eventId` for create/update post payloads. */
export function toPayloadEventId(value) {
  if (value == null || value === "") return null
  const n = Number(value)
  if (Number.isNaN(n) || n === 0) return null
  return n
}
